<template>
  <div class="justify-content-center mb-5 p-5" style="text-align: center">
    <div style="display: inline-flex; align-items: center">
      <div
        class="fts-20"
        style="
          text-align: right;
          font: normal normal normal Segoe UI;
          letter-spacing: 0px;
          color: #ffffff;
          opacity: 1;
          margin-right: 10px;
        "
      >
        Les frais de gestion de votre
      </div>
      <div>
        <select
          class=""
          style="
         border-radius: 20px;
        background: black;
        color: white;
        border: none;
        background: #333436 0% 0% no-repeat padding-box;
        box-shadow: 0px 3px 6px #00000029;
        opacity: 1;
        padding: 5px;
          "
          v-model="comparison"
          @change="onDataChange()"
        >
          <option value="null" disabled>Enveloppe</option>
          <option style="color:black" v-for="(comparison, index) in comparisons_platforms" :key="index" :value="comparison">
            {{ comparison.platform_contract_name }}
          </option>
        </select>
      </div>
      <div
        style="
          text-align: left;
          font: normal normal normal Segoe UI;
          letter-spacing: 0px;
          color: #ffffff;
          opacity: 1;
          margin-left: 10px;
        "
      >
        analysés
      </div>
    </div>

    <div class="row justify-content-center" style="margin-top:30px">
      <div class="fts-20 m-emphasis text-center col-md-4 col-sm-6">
        <div
          style="
            background: #242527 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 30px;
            opacity: 1;
            margin:5px;
            padding: 20px;
          "
        >
          <div
            style="text-align: center;
                font: normal normal normal 1em Segoe UI;
                letter-spacing: 0px;
                color: #FFFFFF;
                opacity: 1;"
          >
            Votre encours:
          </div>
          <div
            style="text-align: center;
                font: normal normal bold 1.7em Segoe UI;
                letter-spacing: 0px;
                color: #9561E2;
                opacity: 1;"
          >
            {{ formatEuros(Math.round(comparison.sum_assets)) }} €
          </div>
        </div>
      </div>
      <div class="fts-20 m-emphasis text-center col-md-4 col-sm-6">
        <div
          style="
            background: #242527 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 30px;
            opacity: 1;
            margin:5px;
            padding: 20px;
          "
        >
          <div
            style="text-align: center;
                font: normal normal normal 1em Segoe UI;
                letter-spacing: 0px;
                color: #FFFFFF;
                opacity: 1;"
          >
            Vos frais annuels:
          </div>
          <div
            style="text-align: center;
                font: normal normal bold 1.7em Segoe UI;
                letter-spacing: 0px;
                color: #9561E2;
                opacity: 1;"
          >
            {{ formatEuros(Math.round(comparison.sum_fees)) }}€ | {{ Math.round((comparison.sum_fees / comparison.sum_assets)*10000)/100 }}%
          </div>
        </div>
      </div>
      <div class="fts-20 m-emphasis text-center col-md-4 col-sm-6">
        <div
          style="
            background: #242527 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 30px;
            opacity: 1;
            margin:5px;
            padding: 20px;
          "
        >
          <div
            style="text-align: center;
                font: normal normal normal 1em Segoe UI;
                letter-spacing: 0px;
                color: #FFFFFF;
                opacity: 1;"
          >
            Vos frais cumulés sur 25 ans:
          </div>
          <div
            style="text-align: center;
                font: normal normal bold 1.7em Segoe UI;
                letter-spacing: 0px;
                color: #9561E2;
                opacity: 1;"
          >
            {{ formatEuros(Math.round(comparison.sum_fees * 25)) }} €
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-center"
      style="text-align: center;
             font: normal normal bold 1.7em Segoe UI;
             letter-spacing: 0px;
             color: #FFFFFF;
             opacity: 1;
             margin-top:30px"
    >
      L'impact des frais sur {{ comparison.platform_contract_name }}
    </div>
    <div class="col-12 mx-auto justify-content-center" style="margin-top:30px">
      <div
        class="row justify-content-center "
        style="background-color: #242527;border-radius: 25px;
     padding: 20px;"
      >
        <canvas ref="chart"></canvas>
      </div>
    </div>
    <div
      class="row justify-content-center"
        style="text-align: center;
               font: normal normal bold 1.7em Segoe UI;
               letter-spacing: 0px;
               color: #FFFFFF;
               opacity: 1;margin-top:30px"
      >
      <p class="fts-20 m-emphasis text-center">
            Economie total sur 25 ans: {{ -total_savings}} €
          </p>
    </div>

    <div
      class="row justify-content-center"
      style="text-align: center;
             font: normal normal bold 1.7em Segoe UI;
             letter-spacing: 0px;
             color: #FFFFFF;
             opacity: 1;margin-top:30px"
    >
      Le détail de vos frais
    </div>

    <div class="row justify-content-center" style="margin-top:30px">
      <div
        class="col-12 m-2"
        style="background: #242527;
               box-shadow: 0px 3px 6px #00000029;
               border-radius: 30px;
               opacity: 1;
               padding: 0px;"
      >
        <table class="">
          <colgroup>
            <col style="width: 25%" />
            <col style="width: 25%" />
            <col style="width: 25%" />
            <col style="width: 25%" />
          </colgroup>
          <thead style=";color: #FFFFFF;">
            <tr>
              <th style="text-align: left; padding:10px">Titre</th>
              <th style="padding:10px">Frais annuels (%/an)</th>
              <th style="padding:10px">Frais potentiels (%/an)</th>
              <th style="padding:10px">Gain sur 25 ans</th>
              <th style="padding:10px">Alternative</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(alternative, i) in comparison.securities" :key="i" style="border-top:2px solid #121212">
              <div
                style="display: contents;
                  font: normal normal normal 1em Segoe UI;
                  letter-spacing: 0px;
                  color: #FFFFFF;
                  opacity: 1;"
                id="random"
                v-if="alternative.hasOwnProperty('security')"
              >
                <td style="text-align: left;padding:10px">
                  {{ alternative.security.name }}
                </td>
                <td style="padding:10px">
                  {{ Math.round(alternative.security.management_fees * 100, 2) / 100 }}
                  %
                </td>
                <td v-if="alternative.hasOwnProperty('alternatives')" style="padding:10px">
                  {{ Math.round(alternative.alternatives.fees * 100, 2) / 100 }}
                  %
                </td>
                <td v-else>
                </td>
                <td v-if="alternative.hasOwnProperty('alternatives')" style="padding:10px">{{ Math.round(alternative.alternatives.saving * 25) }} €</td>
                <td v-else>
                </td>
                <td v-if="alternative.hasOwnProperty('alternatives')" style="padding:10px">{{ alternative.alternatives.name }} - {{ alternative.alternatives.ISIN_code }} </td>
                <td v-else>
                </td>
              </div>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top:30px">
      <b-button href="/scan/extract" class="btnCardContent">
        Optimiser mes frais de gestion
      </b-button>
      <!-- <b-button href="'/scan/extract'"
        style="background: #9561E2 0% 0% no-repeat padding-box;
               box-shadow: 0px 3px 6px #00000029;
               border-radius: 41px;
               opacity: 1;border:none"
        ><span
          style="text-align: center;
                 font: normal normal 600 1em Segoe UI;
                 letter-spacing: 0px;
                 color: #FFFFFF;
                 opacity: 1;"
          >
          Optimiser mes frais de gestion</span
        >
      </b-button> -->
    </div>
  </div>
</template>

<script>
import { Chart } from "chart.js";
export default {
  props: ["comparisons", "comparisons_platforms", "accessgranted", "token", "route"],
  data() {
    return {
      save_portfolios: [],
      total_savings: 0,
      comparison: this.comparisons_platforms[0],
      comps_plats: this.comparisons_platforms[0],
      save_portfolio: [],
      access: "",
      show: false,
      variants: ["primary", "secondary", "success", "warning", "danger", "info", "light", "dark"],
      headerBgVariant: "info",
      headerTextVariant: "light",
      bodyBgVariant: "dark",
      bodyTextVariant: "dark",
      footerBgVariant: "info",
      footerTextVariant: "dark",
      testGraph: null,
    };
  },

  mounted() {
    for (let key in this.comps_plats) {
      this.temp_array = [];
      this.temp_array.push(this.comps_plats[key]["portfolio_saved"]);
      this.temp_array.push(this.comps_plats[key]["platform_contract_id"]);
      this.save_portfolios.push(this.temp_array);
    }
    this.access = this.accessgranted;

    var ctx = this.$refs.chart.getContext("2d");
    var gradient = ctx.createLinearGradient(0, 0, 0, 400);
    var labels = [];

    this.testGraph = new Chart(ctx, {
      type: "line",
      data: {
        datasets: [
          {
            label: "Portefeuille actuel",
            data: [],
            fill: true,
            backgroundColor: "rgb(255, 255, 255,.5)",
            fontFamily: "Poppins",
            pointRadius: 2,
          },
          {
            label: "Portefeuille avec frais optimisés",
            data: [],
            fill: true,
            backgroundColor: "rgba(149, 97, 226, .5)",
            fontFamily: "Poppins",
          },
        ],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          easing: "easeInOutQuad",
          duration: 2000,
        },
        plugins: {
          legend: {
            display: true,
            position: "bottom",
            labels: {
              usePointStyle: true,
              font: {
                size: 16,
              },
              fontFamily: "Poppins",
              boxWidth: 15,
              padding: 30,
            },
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              text: "* Estimation avec une performance de 10% / an"
            },
            grid: {
              display: false,
            },
            ticks: {
              callback: function(value, index, values)
              {
                let date = new Date();
                return date.getFullYear() + index;
              }
            },
          },
          y: {
            grid: {
              display: false,
            },
            ticks: {
              // For a category axis, the val is the index so the lookup via getLabelForValue is needed
              callback: function(value, index, values) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join(" ");
                return value + " " + "€";
              },
            },
          },
        },
      },
    });
    this.onDataChange();
  },

  methods: {
    onDataChange() {
      // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance
      let labels = [];

      var growth_rate = 0.1;
      let data_portfolio = [];
      let data_portfolio_fees = [];

      //benchmark_value = this.amount;
      let porfolio_value = this.comparison.sum_assets;
      var end_year = 25;

      labels[0] = 0;

      data_portfolio[0] = porfolio_value;
      data_portfolio_fees[0] = porfolio_value;

      let portfolio_value_fees = this.comparison.sum_assets_fees;
      let portfolio_value_fees_saving = this.comparison.sum_assets_fees;
      let portfolio_value_no_fees = this.comparison.sum_assets - this.comparison.sum_assets_fees;

      //for (let year = 0; year < horizon; year++)
      for (let year = 1; year < end_year; year++) {
        portfolio_value_fees_saving = portfolio_value_fees_saving*(1 + growth_rate) * (1 - this.comparison.saving_fees)
        portfolio_value_no_fees = portfolio_value_no_fees*(1 + growth_rate)
        portfolio_value_fees = portfolio_value_fees*(1 + growth_rate) * (1 - this.comparison.average_fees)
        //porfolio_value = portfolio_value_fees + portfolio_value_no_fees
        //portfolio_value_fees =  portfolio_value_fees_saving + portfolio_value_no_fees
        data_portfolio[year] = Math.round(portfolio_value_fees + portfolio_value_no_fees);
        data_portfolio_fees[year] = Math.round(portfolio_value_fees_saving + portfolio_value_no_fees);

        labels[year] = year;
      }

      this.total_savings = Math.round(portfolio_value_fees + portfolio_value_no_fees) - Math.round(portfolio_value_fees_saving + portfolio_value_no_fees)

      this.testGraph.data.labels = labels;
      this.testGraph.data.datasets[0].data = data_portfolio;
      this.testGraph.data.datasets[1].data = data_portfolio_fees;
      this.testGraph.update();
    },
    formatEuros(number)
    {
        return this.$utils.numberWithSpaces(Number(number).toFixed(0));
    },
  },
};
</script>
